import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadMask from "../../../Utils/LoadMask/LoadMask";
import CardSimple from '../../../Utils/Cards/cardSimple';
import CajasChicasGrid from './CajasChicasGrid';

// import SeriesForm from './SeriesForm';

class PermisosCajaChica extends Component {
    state = {
        titulo: 'EDITAR ACCESOS',
    }

    render() {
        const { loader } = this.props;

        return (
            <CardSimple titulo = {this.state.titulo}>
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <CajasChicasGrid
                        {...this.props}
                        data={this.props.data}
                        guardar={this.props.guardar}
                    />
                </LoadMask>
            </CardSimple>
        );
    }
}

export default PermisosCajaChica;
